module.exports = __webpack_public_path__ + "static/media/file-animation.28adff81.gif";